import { IWPImage, IWPLink } from "@/src/types";
import React, { useRef, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import S from "./MainBlock.styled";
import { MainInner } from "@/styles/global";
import { Link } from "gatsby";
import { paragraph, Wysiwyg } from "@/styles/typography";

import { AnimationOnScroll } from "react-animation-on-scroll";
import styled from "styled-components";
export interface Props {
  animation: string;
  title: string;
  subtitle: string;
  text: string;
  backgroundImage?: IWPImage;
  backgroundVideo?: { mediaItemUrl: string; mimeType: string };
  selectMedia: string;
  selectSide?: string;
  side: string;
  awardImage?: IWPImage;
  link?: IWPLink;
  autoplay: boolean;
  vimeoIframe: string;
}

const MainBlock: React.FC<Props> = ({
  awardImage,
  title,
  subtitle,
  text,
  backgroundImage,
  backgroundVideo,
  selectMedia,
  selectSide,
  link,
  autoplay,
  vimeoIframe,
  animation,
}) => {
  const backgroundImageData = backgroundImage?.localFile?.childImageSharp
    ?.gatsbyImageData
    ? getImage(backgroundImage.localFile.childImageSharp.gatsbyImageData)
    : null;
  const awardImageData = awardImage?.localFile?.childImageSharp?.gatsbyImageData
    ? getImage(awardImage.localFile.childImageSharp.gatsbyImageData)
    : null;

  //Bad workaround starts here. Bad solution, but there is an error for styling on Safari at current date, which this workaround fixes. Bad workaround starts here

  const TextWrapperMobile = styled.div`
    text-align: right;
    width: fit-content;
    align-items: flex-end;
    margin-top: 2px;
    display: flex;
    flex-direction: column;
  `;

  const TextLinkMobile = styled(Link)`
    color: ${({ theme }) => theme.colors.tango};
    text-align: right !important;
    text-decoration: none;
    font-size: 16px;
    line-height: 20px;
    width: fit-content;
    font-size: 22px;
    p {
      margin: 0;
      color: ${({ theme }) => theme.colors.tango};
      text-align: right !important;
    }
  `;

  const SubtitleMobile = styled(paragraph)`
    color: ${({ theme }) => theme.colors.tango} !important;
    text-align: right !important;
    font-size: 20px;
    margin-top: 2px;
    font-size: 16px;
    line-height: 20px;
  `;

  const mobileText = (link: IWPLink) => {
    const splitSubtitle = subtitle?.includes(" ") ? subtitle.split(" ") : null;
    return (
      <TextWrapperMobile>
        <TextLinkMobile to={link.url}>
          <SubtitleMobile>
            {splitSubtitle ? splitSubtitle[1] : subtitle}
          </SubtitleMobile>
        </TextLinkMobile>
        <TextLinkMobile to={link.url}>
          <SubtitleMobile>
            {splitSubtitle ? splitSubtitle[0] : subtitle}
          </SubtitleMobile>
        </TextLinkMobile>
      </TextWrapperMobile>
    );
  };

  const mobileTextNoLink = () => {
    const splitSubtitle = subtitle?.includes(" ") ? subtitle.split(" ") : null;

    return (
      <TextWrapperMobile>
        {subtitle && (
          <SubtitleMobile>
            {splitSubtitle ? splitSubtitle[1] : subtitle}
          </SubtitleMobile>
        )}
        {subtitle && (
          <SubtitleMobile>
            {splitSubtitle ? splitSubtitle[0] : subtitle}
          </SubtitleMobile>
        )}
      </TextWrapperMobile>
    );
  };

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);
      setTimeout(() => {
        setWindowWidth(window.innerWidth);
      }, 1000);
    }
  }, []);

  const [windowWidth, setWindowWidth] = React.useState(0);

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      //listen to window resize
      window.addEventListener("resize", () => {
        setWindowWidth(window.innerWidth);
      });
    }
  }, [windowWidth]);

  // Bad workaround ends here

  const renderComponent = () => {
    if (link) {
      return (
        <S.Container>
          {backgroundImageData && selectMedia === "image" && (
            <Link to={link.url}>
              <S.Image
                image={backgroundImageData}
                alt={backgroundImage?.altText || ""}
              />
            </Link>
          )}

          {backgroundVideo && selectMedia === "video" && (
            <S.BackgroundVideo>
              {autoplay ? (
                <Link to={link.url}>
                  <video autoPlay loop muted playsInline>
                    <source
                      src={backgroundVideo.mediaItemUrl}
                      type={backgroundVideo.mimeType}
                    />
                  </video>
                </Link>
              ) : (
                <video controls poster={backgroundImage?.sourceUrl}>
                  <source
                    src={backgroundVideo.mediaItemUrl}
                    type={backgroundVideo.mimeType}
                  />
                </video>
              )}
            </S.BackgroundVideo>
          )}
          {vimeoIframe && selectMedia === "vimeo" && (
            <Link to={link.url}>
              <S.VimeoWrapper>
                <S.Overlay />
                {backgroundImageData && (
                  <S.Image
                    image={backgroundImageData}
                    alt={backgroundImage?.altText || ""}
                  />
                )}
                <div
                  className="vimeo"
                  dangerouslySetInnerHTML={{ __html: vimeoIframe }}
                />
              </S.VimeoWrapper>
            </Link>
          )}
          {awardImageData && (
            <S.AwardImage
              image={awardImageData}
              alt={awardImage?.altText || ""}
            />
          )}
          <S.TextContainer>
            <S.TextLink to={link.url}>
              {title && (
                <>
                  <S.TitleWrapper>
                    <S.Title> {title}</S.Title>
                  </S.TitleWrapper>
                  <S.TitleTextWrapperMobile>
                    <S.TitleWrapperMobile>{title}</S.TitleWrapperMobile>
                    <S.TextLink to={link.url}>
                      <S.Text>{text && text}</S.Text>
                    </S.TextLink>
                  </S.TitleTextWrapperMobile>
                </>
              )}
            </S.TextLink>
            {windowWidth >= 692 && (
              <S.TextWrapper>
                {subtitle && (
                  <S.TextLink to={link.url}>
                    <S.Subtitle> {subtitle}</S.Subtitle>
                  </S.TextLink>
                )}
                {subtitle && windowWidth < 692 && mobileText(link)}
                {text && (
                  <S.TextLink to={link.url}>
                    <S.Text>{text}</S.Text>
                  </S.TextLink>
                )}
              </S.TextWrapper>
            )}
          </S.TextContainer>
        </S.Container>
      );
    } else {
      return (
        <S.Container>
          {backgroundImageData && selectMedia === "image" && (
            <S.Image
              image={backgroundImageData}
              alt={backgroundImage?.altText || ""}
            />
          )}

          {backgroundVideo && selectMedia === "video" && (
            <S.BackgroundVideo>
              {autoplay ? (
                <video autoPlay loop muted playsInline>
                  <source
                    src={backgroundVideo.mediaItemUrl}
                    type={backgroundVideo.mimeType}
                  />
                </video>
              ) : (
                <video controls poster={backgroundImage?.sourceUrl}>
                  <source
                    src={backgroundVideo.mediaItemUrl}
                    type={backgroundVideo.mimeType}
                  />
                </video>
              )}
            </S.BackgroundVideo>
          )}
          {vimeoIframe && selectMedia === "vimeo" && (
            <div
              className="vimeo"
              style={{position: 'relative'}}
              dangerouslySetInnerHTML={{ __html: vimeoIframe }}
            />
          )}
          {awardImageData && (
            <S.AwardImage
              image={awardImageData}
              alt={awardImage?.altText || ""}
            />
          )}

          <S.TextContainer>
            <S.TitleWrapper>
              {title && <S.Title> {title}</S.Title>}
            </S.TitleWrapper>
            {windowWidth >= 692 && (
              <S.TextWrapper>
                {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
                {text && <S.Text>{text}</S.Text>}
              </S.TextWrapper>
            )}
            {windowWidth < 692 && mobileTextNoLink()}
          </S.TextContainer>
        </S.Container>
      );
    }
  };

  return (
    <AnimationOnScroll
      animateIn={`animate__${animation}`}
      animateOnce={true}
      initiallyVisible={animation == "none" ? true : false}
      duration={animation === "none" ? 0 : 1}
      delay={animation === "none" ? 0 : 100}
    >
      <MainInner>{renderComponent()}</MainInner>
    </AnimationOnScroll>
  );
};

export default MainBlock;
